import React from "react";

const Icon = ({ name, ...props }) => {
  if (!name) return null;

  const IconComponent = require(`./${name}.js`).default;

  return <IconComponent {...props} />;
};

export default Icon;
